<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>A Canadian Girl in South Africa</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="image-title"><img alt="images" src="images/Page_11.jpg"/></p>
<p class="figcaption"><a id="page_x"><em class="italic">Maud Graham, 1908.<br/><span class="fig">[Joan Chandler private collection]</span></em></a></p><a id="page_x">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Page_11.vue?76a46fcc